import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {useContactSelectStore} from '@/store/contactSelect';
import Loading from '@/components/Loading.vue';
import {computed} from 'vue';
import Contact from '@/model/Contact';

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectContact',
  props: {
    modelValue: {},
    showLabel: { type: Boolean },
    disabled: { type: Boolean },
    kundenNr: {},
    rules: {}
  },
  emits: {'update:modelValue': (data: Array<{AnsprechpartnerNr?: number}>) => Array.isArray(data)},
  setup(__props: any, { expose: __expose, emit: __emit }) {

const store = useContactSelectStore();
const props = __props;

const emit = __emit;

store.fetch(props.kundenNr).catch(console.error);

const internalValue = computed({
  get(): number | undefined {
    if (!props.modelValue?.length) return undefined;
    const temp = props.modelValue[0].AnsprechpartnerNr;
    console.log(`internalValue: ${typeof temp} ${temp}`);
    return temp ? Number(temp) : temp;
  },
  set(newVal: number | undefined) {
    if (newVal != undefined && newVal >= 0) {
      emit('update:modelValue', [{AnsprechpartnerNr: newVal}]);
      return;
    } else {
      emit('update:modelValue', []);
      return;
    }
  },
});

const contactLabel = (item: Contact) => {
  console.log('contactLabel: ', item);
  // @ts-expect-error
  if (item === 0) {
    return 'ohne Ansprechpartner';
  }
  if (item.Vorname == '') {
    return item.Nachname;
  }
  return item.Nachname + ', ' + item.Vorname;
};

__expose({
  store,
  internalValue,
  fetch,
  props,
  Loading,
  Error,
  contactLabel,
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_unref(store).error)
    ? (_openBlock(), _createBlock(_component_v_alert, {
        key: 0,
        type: "error",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "grow" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Fehler: " + _toDisplayString(_unref(store).error.message), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "shrink" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).fetch(_ctx.kundenNr))),
                    size: "small",
                    loading: _unref(store).loading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Erneut versuchen")
                    ], undefined, true),
                    _: 1
                  }, 8, ["loading"])
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_select, {
        key: 1,
        variant: !_ctx.showLabel ? 'solo' : undefined,
        density: !_ctx.showLabel ? 'compact' : 'default',
        label: "Ansprechpartner",
        "hide-details": "",
        class: "mt-3 mb-2",
        modelValue: internalValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((internalValue).value = $event)),
        "item-title": contactLabel,
        "item-value": "AnsprechpartnerNr",
        items: _unref(store).data,
        loading: _unref(store).loading,
        placeholder: "--- Ansprechpartner wählen ---",
        "return-object": false,
        rules: _ctx.rules,
        clearable: "",
        disabled: _ctx.disabled
      }, null, 8, ["variant", "density", "modelValue", "items", "loading", "rules", "disabled"]))
}
}

})